<script>
  export let editor
  export let key
</script>

{#if editor}
  <button class="btn" class:active={editor.isActive(key)} on:click>
    <slot />
  </button>
{/if}

<style>
  button {
    margin: 0;
  }

  button.active {
    background: black;
    color: white;
  }
</style>
